import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef} from '@angular/core';
import {EmpleadoComisionesModel} from '../models/empleado.comisiones.model';
import {CargoServices} from '../../CoreModule/services/cargo.services';
import {ComisionServices} from '../services/comision.services';
import {getLoginUserFull} from '../../CoreModule/services/usuario.services';
import * as moment from 'moment';
import {cargo} from 'async';
import {CargoEntity} from '../../CoreModule/entities/cargo.entity';
import {ComisionModel} from '../models/comision.model';
import {NgxSpinnerService} from 'ngx-spinner';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';

@Component({
  selector: 'detalle-comision',
  templateUrl: '../templates/detalle.comision.template.html'
})
export class DetalleComisionEmpleado implements OnInit, OnChanges {

  @Input()
  empleado: EmpleadoComisionesModel;

  @Input()
  row: any;

  @Input()
  listaCargos: CargoEntity[] = [];

  @Input()
  comision: ComisionModel;

  cargoActual: CargoEntity;

  @Input()
  fechaIni: any;

  @Input()
  fechaFin: any;

  @Input()
  cambiarValor: boolean = false;

  @Input()
  canEliminarComision: boolean = true;

  @Input()
  aproEmpleado: boolean = false;

  @Input()
  cambiarCargo: boolean = false;

  @Input()
  cambiarTienda: boolean = false;

  @Input()
  agregarObservacion: boolean = false;

  @Output()
  recalculoRealizado = new EventEmitter<any>();

  @Output()
  empleadoEliminado = new EventEmitter<any>();

  @Output()
  empleadoAProbado = new EventEmitter<any>();

  @Output()
  actualizacionComRealizada = new EventEmitter<any>();

  valorNuevoApro:number = 0;

  modalRef: BsModalRef;

  newObs: string = '';

  rows: any[] = [];
  listaTiendas:TiendaEntity[] = [];

  constructor(private cs: CargoServices, private ecs: ComisionServices, private spinner: NgxSpinnerService, private modS:BsModalService) {

  }

  ngOnInit(): void {

    this.cs.getCargo(this.empleado.cargo._id).subscribe((d: any) => {

      this.empleado.cargo = d.data.cargo;
      // this.empleado.tempValueCom = 0;
      this.cargoActual = this.empleado.cargo;

      console.log(this.empleado);

      for (let m of this.empleado.mallas) {

        let metaPeriodo = 0;
        let ventas = this.empleado.devolverVentaXSemana(m.semana);


        // console.log(ventas.filter(v=>{return v.tienda == "130"}));
        // console.log(ventas.filter(v=>{return v.tienda == "013"}));
        let totalVentas = 0;
      //   //
        let t = this.empleado.tiendas.find(_t => _t.idDB == m.tienda);

        ventas.map(v => {

          if(v.tienda == t.idDB)
            totalVentas += v.cantidad;

        });
        //
        let diasProg = 0;
        let diasCom = 0;
        m.meta.map(md => {
          let fecha = moment(md.fecha);
          fecha.seconds(0).millisecond(0);
          if (fecha.isBetween(this.fechaIni, this.fechaFin, undefined, '[]')) {
            metaPeriodo += md.metaDia;
            if (md.metaDia > 0)
              diasProg++;
            else if(md.esCompensado)
              diasCom++;
          }
        });
        let cumplimiento = (metaPeriodo == 0) ? 0 : totalVentas / metaPeriodo * 100;
        //
        // let cantDias = this.fechaFin.diff(this.fechaIni,'d');
        let comision = this.empleado.devolverValorComision(cumplimiento, t.categoria, -1, diasProg + diasCom);

        this.empleado.tiendas.map(t2=>{
          let tfound = this.listaTiendas.find(_t2=> _t2.idDB == t2.idDB);

          if(!tfound)
            this.listaTiendas.push(t2);
        });

        //
        this.rows.push({
          semana: m.semana,
          tienda: t.nombre,
          categoria: t.categoria,
          meta: metaPeriodo,
          venta: totalVentas,
          cumplimiento: cumplimiento,
          diasProg: diasProg,
          diasCom:diasCom,
          comision: comision
        });
      }

    });

  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  actualizarTiendaMaestra(){
    console.log(this.empleado.tiendaMaestra);
    this.spinner.show();

    this.empleado.observaciones.push("Actualizando la tienda maestra");
    this.empleado.fechaObs.push(moment().toISOString());
    this.empleado.usuarioAprueba.push(getLoginUserFull().nombres);
    this.ecs.updateTiendaEmpleComision(this.empleado._id, this.empleado.tiendaMaestra, this.empleado.observaciones, this.empleado.usuarioAprueba,this.empleado.fechaObs).subscribe(d=>{
      this.spinner.hide();
      this.empleado.aprobado = false;
      this.empleado.estado.paraAprobacion = 0;
    })
  }



  addObservacion() {
    this.empleado.observaciones.push(this.newObs);
    this.empleado.fechaObs.push(moment().toISOString());
    this.empleado.usuarioAprueba.push(getLoginUserFull().nombres);
    this.newObs = '';

    this.spinner.show();
    this.ecs.actualizarComisionV2(this.empleado._id, this.empleado.totCat.valorNeto, this.empleado.totTienda.valorNeto, this.empleado.observaciones, this.empleado.usuarioAprueba, this.empleado.fechaObs).subscribe(d => {
      // console.log(d);
      this.spinner.hide();
    });
  }

  actualizarValor() {

    if(this.empleado.tempObs == '') {
      alert(`No se puede actualizar el valor porque el campo de observación esta en blanco`);
      return ;
    }

    this.spinner.show();
    this.empleado.totCat.valorNeto = this.empleado.tempValueCom;

    if(this.empleado.cargo.idDB  == "070")
    {
      this.empleado.totTienda.valor = this.empleado.totCat.valorNeto;
    }
    this.ecs.actualizarComisionV2(this.empleado._id, this.empleado.totCat.valorNeto, this.empleado.totTienda.valorNeto, this.empleado.observaciones, this.empleado.usuarioAprueba, this.empleado.fechaObs).subscribe(d => {
      console.log(d);
      this.spinner.hide();
      this.actualizacionComRealizada.emit(this.empleado);
    });
  }

  aprobarEmpleado() {
    this.empleado.aprobado = true;

    this.spinner.show();
    this.ecs.aprobarManualComision(this.empleado._id, this.empleado.observaciones, this.empleado.usuarioAprueba, this.empleado.fechaObs).subscribe(d => {
      console.log(d);
      this.spinner.hide();
      this.empleadoAProbado.emit(this.empleado);
    });
  }

  cambiarComision(event) {

    let c = this.listaCargos.find(cs => cs.idDB == event.target.value);
    if (c) {
      this.cargoActual = c;
      //this.empleado.cargo = c;
    }

  }

  recalcularComision() {
    let f1 = moment(this.comision.fechaInicio).seconds(0).millisecond(0);
    let f2 = moment(this.comision.fechaFin).seconds(0).millisecond(0);
    this.spinner.show();

    this.cs.getCargo(this.cargoActual._id).subscribe(d => {

      this.empleado.cargo = d.data.cargo;

      this.ecs.getInfoEmpleadoCalendarioTienda(this.empleado.empleado.id, this.empleado.tiendaMaestra, f1.format('DD-MM-YYYY'), f2.format('DD-MM-YYYY')).subscribe(d => {
        let data = d.data.infoMetaEmpleadoCalendarioTienda;


        this.empleado.ventasTienda = data.ventasTienda;
        this.empleado.pptoTienda = data.pptoTienda;

        this.empleado.calcularComision(data.ventas, this.empleado.tiendas, f1, f2);

        this.recalculoRealizado.emit(this.empleado);

        this.ecs.addEmpleComision(this.comision._id, this.empleado).subscribe(d2=>{

          this.spinner.hide();
        });



      });
    });


  }


  openModalEliminar(template:TemplateRef<any>){
    this.modalRef = this.modS.show(template);
  }

  eliminarComision(){
    this.modalRef.hide();
    this.spinner.show();

    this.ecs.eliminarEmpleComision(this.empleado._id).subscribe(d=>{
      console.log(this.empleadoEliminado);
      this.empleadoEliminado.emit(this.empleado);
      this.spinner.hide();
    })

  }

}
